import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "../../../../../../utils/hooks/useMutationWithError";
import {
  UserContactStatus,
  useCheckUserEmailStatusMutation,
} from "./__generated__/useCheckUserEmailStatusMutation.graphql";

export const useCheckUserEmailStatus = () => {
  const [checkStatus, isChecking] =
    useMutationWithError<useCheckUserEmailStatusMutation>(
      useCheckEmailMutationString
    );

  const checkEmail = (
    email: string,
    onCompleteHandler: (
      value: string,
      result: UserContactStatus,
      type: "Email"
    ) => void
  ) => {
    checkStatus({
      variables: { input: { email } },
      onCompleted: (res) => {
        if (res.responsePayload?.success && res.responsePayload.result) {
          onCompleteHandler(email, res.responsePayload.result, "Email");
        }
      },
    });
  };
  return [checkEmail, isChecking] as const;
};

export const useCheckEmailMutationString = graphql`
  mutation useCheckUserEmailStatusMutation($input: UserEmailStatusInput!) {
    responsePayload: userEmailStatus(input: $input) {
      success
      result
      errors {
        field
        code
        message: code
      }
    }
  }
`;
